
class FloorController {
    /*@ngInject*/
    constructor($scope, $stateParams, $state, orderStore, utils, $q, auth) {
        "ngInject";
		_.extend(this, {
			$scope: $scope,
			$stateParams: $stateParams,
			$state: $state,
			orderStore: orderStore,
            utils: utils,
            $q: $q,
            auth: auth
		});
       
        // this.enterKey(event);
        this.floorList = [{ value: 0, displayName: 'Ground' }];
        this.floorList = this.floorList.concat(_.times(120, (i) => ({value: i + 1, displayName: this.utils.ordinalSuffixOf(i + 1)}))); //floor count limited to 120

        this.liftAvailability = [
            {displayName: 'available', value: true},
            {displayName: 'not available', value: false}
        ];

        this.orderLoader = this.orderStore.getOrderWithRedirectionCheck($stateParams.orderId)
            .then(
                (order) => {
                    this.order = order;
                },
                (error) => this.$q.reject(error)
            );
    }


    enterKey(keyEvent) {
        if (keyEvent.which == 13 || keyEvent.keyCode == 13) {
            this.goToHome();
        }
    }
    checkIfValidForm() {
        const form = this.floorForm;

        // Set form as submitted
        form.$setSubmitted();
        return form.$valid;
        

    }

    goToHome() {
        const isValidForm = this.checkIfValidForm();
        if (!isValidForm) {
            return false;
        }

        this.orderLoader = this.orderStore.saveOrder(this.order, true)
            .then(
                (order) => {
                    let nextState = this.utils.getAdminStateIfApplicable('base.home');
                    if (this.auth.isAuthenticated() || (this.auth.isAdminUser() && this.order.user_id)) {
                        this.$state.go(nextState, {orderId: order.id});
                    } else {
                        let nextState = this.utils.getAdminStateIfApplicable('base.login'),
                            redirectState = this.utils.getAdminStateIfApplicable('base.home');
                        this.$state.go(nextState, {orderId: this.order.id, redirect: redirectState, showSavePopup: false});
                    }
                },
                (error) => console.log(error)
            );
    }

}

FloorController.bindings = {
    sourceFloor: '@',
    sourceService: '@',
    destinationFloor: '@',
    destinationService: '@'
};


export default FloorController;


// WEBPACK FOOTER //
// ./client/app/components/floor/floor.controller.js